<script>
    import CRUD from './CRUD.svelte';
    import { fetchClientes, saveCliente, removeCliente, searchClientes, subscribeToClientes, unsubscribeFromClientes, fetchAtributosCliente } from '../controllers/clienteController.js';
    import { fetchSucursales } from '../controllers/sucursalController.js'; // Para cargar sucursales
    import { fetchVendedores } from '../controllers/vendedorController.js'; // Para cargar vendedores
    import { onMount } from 'svelte';
    import { t } from 'svelte-i18n';

    let clienteColumns = [
      { label: 'Sucursal', field: 'sucursal_descrip', type: 'text' },
      { label: $t('fields.name'), field: 'nombre', type: 'text' },
      { label: 'NIT', field: 'nit', type: 'text' },
      { label: 'Vendedor', field: 'vendedor_nombre', type: 'text' },
      { label: 'Email', field: 'correo', type: 'text' },
      { label: $t('fields.state'), field: 'sta', type: 'bool' },
    ];

    // Estructura del nuevo objeto Cliente
    let newCliente = {
      sucursal: '',  // Tipo JSON con opciones de sucursales
      nombre: '',
      email: '',
      sta: true,
      atributos: [], // Atributos adicionales
    };

    let editColumns = [
        { label: 'Sucursal', key: 'sucursal', type: 'select', required: true, fetchOptions: { key: 'id', value: 'descrip' }, options: [] },
        { label: $t('fields.name'), key: 'nombre', type: 'text', required: true },
        { label: 'NIT', key: 'nit', type: 'text', required: true },
        { label: 'Email', key: 'correo', type: 'email', required: true },
        { label: 'Vendedor', key: 'vendedor', type: 'select', required: true, fetchOptions: { key: 'id', value: 'nombre' }, options: [] },
        { label: $t('fields.state'), key: 'sta', type: 'checkbox', required: true },
    ];

    // Función genérica para cargar opciones de cualquier entidad
    async function loadOptions(fetchFunction, targetKey) {
        try {
            const fetchedData = await fetchFunction();

            if (Array.isArray(fetchedData[targetKey])) {
                const options = fetchedData[targetKey].map(e => ({
                    key: e[editColumns.find(col => col.key === targetKey).fetchOptions.key],
                    value: e[editColumns.find(col => col.key === targetKey).fetchOptions.value],
                }));

                // Asigna las opciones transformadas a la columna correspondiente
                editColumns.find(column => column.key === targetKey).options = options;
            } else {
                console.error(`Se esperaba un array de ${targetKey}, pero se obtuvo:`, fetchedData);
            }
        } catch (error) {
            console.error(`Error al cargar las opciones para ${targetKey}:`, error);
        }
    }


    // Cargar las sucursales al montar el componente
    onMount(() => {
        loadOptions(fetchSucursales, 'sucursal');
        loadOptions(fetchVendedores, 'vendedor');
    });
</script>

<CRUD 
    title={$t('entities.clientes')}
    entityName="cliente"
    newEntity={newCliente}
    columns={clienteColumns}
    fetchEntities={fetchClientes}
    saveEntity={saveCliente}
    removeEntity={removeCliente}
    searchEntities={searchClientes}
    subscribeToChanges={subscribeToClientes}
    unsubscribeFromChanges={unsubscribeFromClientes}
    editColumns={editColumns}
    fetchAtributos={fetchAtributosCliente}
/>